import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { compose, lifecycle, setDisplayName, withState } from 'recompose';
import { bindActionCreators } from 'redux';
import { usersAction } from '@/actions';
import { getShopOnboardingLink } from '@/apis';
import { paths } from '@/config';
import notify from '@/migration/notification';

const mapStateToProps = (state) => ({
  router: state.router,
  form: state.form.toJS(),
  users: state.users.toJS(),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...usersAction, notify, push }, dispatch);

const enhance = compose(
  setDisplayName('StripeRefreshCallback'),
  connect(mapStateToProps, mapDispatchToProps),
  withState('isLoading', 'isLoadingUpdater', true),
  lifecycle({
    async componentDidMount() {
      const { getMe, isLoadingUpdater, push } = this.props;

      try {
        await getMe();
      } catch (error) {
        push(paths.before.signin);
        notify(
          'セッションが切れました。再度、ログインを行なってください',
          'error',
          undefined,
          5
        );
        return;
      }

      const {
        users: { mydata },
      } = this.props;

      try {
        const result = await getShopOnboardingLink(mydata.id);
        if (result instanceof Error) {
          throw result;
        }
        window.location.href = result.onboarding_url;
      } catch (error) {
        push(paths.mypage.bank_account);
        notify(
          '口座登録の再開に失敗しました。再度お試しください',
          'error',
          undefined,
          5
        );
      }

      isLoadingUpdater(false);
    },
  })
);

export default enhance;
